<div style="margin-left: 35px; margin-top: 20px; margin-bottom: 0px">
    {{ title }}
</div>
<button mat-raised-button style="margin-left: 35px; margin-top: 20px; margin-bottom: 0px" (click)="changeAudioGraph('original')">
  Original
</button>
<button mat-raised-button style="margin-left: 35px; margin-top: 20px; margin-bottom: 0px" (click)="changeAudioGraph('stitched')">
  Stitched
</button>

<div class="linechart"></div>